import React from 'react'
import ModalWrapper from 'components/modals/ModalWrapper'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { withRouter } from 'react-router'
import { MODAL_CLIENT_ADMIN_CODE } from 'redux/modules/modals'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import NumComponent from 'components/numPad/NumComponent'
const styles = theme => ({
  textField: {
    height: 40
  },
  textFieldInput: {
    fontSize: '40px'
  },
  input: {
    padding: 0
  }
})
const numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0]
class AdminCodeModal extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    adminCode: PropTypes.string.isRequired,
    hideModal: PropTypes.func.isRequired
  }
  state = {
    value: '',
    error: void 0
  }
  handleClick = value => {
    let newValue = `${this.state.value}${value}`
    let error
    if (newValue === this.props.adminCode) {
      this.props.hideModal(MODAL_CLIENT_ADMIN_CODE)
      this.props.history.replace('/admin')
      return
    } else if (newValue.length === 4) {
      newValue = ''
      error = 'Mauvais Code ! (code par défaut : 0000)'
    }
    this.setState({ value: newValue, error: error })
  }

  render() {
    const { classes } = this.props
    return (
      <ModalWrapper
        appBar
        open
        title={`Administration`}
        showCancel
        showOk={false}>
        <Grid
          container
          direction="row"
          alignItems="center"
          justify="space-around">
          <Grid
            item
            xs={12}
            container
            direction="column"
            alignItems="center"
            justify="flex-start">
            <Grid item xs={8}>
              <Paper elevation={3} style={{ width: 200, marginBottom: 10 }}>
                <Grid container alignItems="center" justify="center">
                  <Grid style={{ paddingTop: 0 }} item xs={4}>
                    <TextField
                      className={classes.textField}
                      value={this.state.value}
                      type="password"
                      id="bootstrap-input"
                      InputProps={{
                        disableUnderline: true,
                        classes: {
                          root: classes.textFieldInput,
                          input: classes.input
                        }
                      }}
                    />
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
            {this.state.error && (
              <Typography variant="caption" color="secondary" gutterBottom>
                {this.state.error}
              </Typography>
            )}
            <Grid
              style={{ maxWidth: 400 }}
              item
              xs={12}
              md={12}
              container
              direction="row"
              alignItems="center"
              justify="center"
              spacing={40}>
              {numbers.map((value, index) => {
                return (
                  <Grid key={index} item xs={4} md={4}>
                    <NumComponent onClick={this.handleClick} value={value} />
                  </Grid>
                )
              })}
            </Grid>
          </Grid>
        </Grid>
      </ModalWrapper>
    )
  }
}

export default withRouter(withStyles(styles)(AdminCodeModal))



// WEBPACK FOOTER //
// ./src/components/modals/client/AdminCodeModal.js